import * as Yup from 'yup';

const associateBuildStudentSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().optional()
  });

  export default associateBuildStudentSchema;